import React from "react";
import Button from "../ui/Button";
import { Microscope } from "lucide-react";

const ProcurementOptions = ({
  title,
  description,
  descriptionTitle,
  options = [],
  showButton = false,
  icon: IconProp,
}) => {
  return (
    <section className="py-8 md:py-16 px-4 bg-white font-sans">
      {/* Header Section */}
      <div className="max-w-[1800px] mx-auto text-center mb-12">
        <h2 className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] font-bold text-[#183076] mb-4">
          {title}
        </h2>
        {descriptionTitle && (
          <p className="max-w-[1281px] mx-auto leading-relaxed text-[18px] md:text-[24px] text-gray-700">
            {descriptionTitle}
          </p>
        )}
      </div>

      {/* Cards Container: Flex-wrap ensures 5 cards look balanced */}
      <div className="flex flex-wrap justify-center gap-[20px] 2xl:gap-[50px] max-w-[1800px] mx-auto">
        {options.map((option, index) => (
          <div
            key={index}
            className="group border border-[#183076] rounded-[20px] lg:rounded-[40px] px-[20px] lg:px-[40px] py-[22px] lg:py-[48px] flex flex-col items-start transition-all duration-500 hover:shadow-lg bg-transparent hover:border-blue-200 relative overflow-hidden 
            /* Responsive Width Logic */
            w-full md:w-[calc(48%)] xl:w-[calc(31%)] 2xl:w-[calc(30%)]"
            style={{
              "--hover-gradient":
                "radial-gradient(80% 80% at 100% 100%, rgba(0, 152, 176, 0.15) 0%, rgba(0, 152, 176, 0) 100%)",
            }}
          >
            {/* Hover Background Effect */}
            <div
              className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
              style={{
                background:
                  "radial-gradient(80% 80% at 100% 100%, rgba(0, 152, 176, 0.15) 0%, rgba(0, 152, 176, 0) 100%)",
              }}
            />

            {/* Content Wrapper */}
            <div className="relative z-10 flex flex-col justify-between h-full w-full">
              <div>
                <div className="mb-[30px] lg:mb-[52px] p-2 border border-[#183076] rounded-lg inline-block bg-white shadow-sm">
                  {IconProp ? (
                    <IconProp
                      className="w-8 h-8 text-[#183076]"
                      strokeWidth={1.5}
                    />
                  ) : (
                    <Microscope
                      className="w-8 h-8 text-[#183076]"
                      strokeWidth={1.5}
                    />
                  )}
                </div>
              </div>

              <div>
                <h3 className="text-[20px] md:text-[24px] 2xl:text-[30px] font-bold text-[#183076] mb-4 leading-tight">
                  {option.title}
                </h3>

                <p className="leading-relaxed text-[16px] md:text-[20px] xl:text-[24px] text-[#183076] text-justify">
                  {option.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Action Button */}
      {showButton && (
        <div className="w-full flex items-center justify-center mt-[50px]">
          <Button
            className="px-[14px] md:px-[20px] xl:px-[40px] py-[10px] md:py-[18px] border text-[18px] xl:text-[24px] border-[#183076] text-[#183076] font-medium rounded-[50px] 
                       transition-all duration-300 ease-in-out 
                       hover:bg-[#183076] hover:text-white hover:shadow-lg active:scale-95 w-full sm:w-auto"
            text="Explore Now"
            to="/quality-compliance"
          />
        </div>
      )}
    </section>
  );
};

export default ProcurementOptions;
